// extracted by mini-css-extract-plugin
export default {"AttachmentsChooser":"GgejS_YyNkG3OIxf6WvQ"};